import React from 'react'

export const ModalBody = ({rander}) => (
  <div className="relative p-4 flex-auto">
      {rander}
  </div>
)
